export enum UserRole {
  master = 'master',
  admin = 'admin',
}

export enum StorageKeys {
  session_token = 'session-token',
}

export type serverError = { status: number; data: null; message: string };

export type ErrorMessage = { [key: string]: { [errorKey: string]: string } };

export type StringOrNull = string | null;
export type NumberOrNull = number | null;
export type DateOrNull = Date | null;
export type BoolOrNull = boolean | null;
export type FileOrNull = File | null;

export enum AppSection {
  products = 'products',
  contact_card = 'contact_card',
  capacitation = 'capacitation',
  cubator_selection = 'cubator_selection',
  quote_list = 'quote_list',
  sale_points = 'sale_points',
  promotions = 'promotions',
  faq = 'faq',
  certificate = 'certificate',
  projects = 'projects',
  assistant = 'assistant',
}

export enum LinkType {
  external = 'external',
  app = 'app',
  none = 'none',
}

export enum ProductType {
  CEMENTO = 'CEMENTO',
  HORMIGON = 'HORMIGON',
}

export enum CementCode {
  cimiento = 'C_C',
  radieres = 'C_R',
  pilares = 'C_P',
  pavimento = 'C_V',
  mortero = 'C_M',
  estuco = 'C_E',
}

export enum ConcreteCode {
  cimiento = 'H_C',
  radieres = 'H_R',
  pilares = 'H_P',
  pavimento = 'H_V',
  mortero = 'H_M',
  estuco = 'H_E',
}

export type SelectOption = {
  label: string;
  value: string | number;
};


export interface OrderItem {
  field: string;
  order: 'ASC' | 'DESC';
}

export interface SearchItem {
  field: string;
  value: string;
}

export interface IQueryParams {
  order?: OrderItem;
  limit?: number;
  offset?: number;
  search?: SearchItem[];
}


export interface IListResponse<T> {
  total_items: number;
  items: T[];
}

export interface ISimpleListResponse<T> {
  items: T[];
}

export interface IBulkErrorItem<C> {
  tableRow: number;
  item: C;
  errors: string[];
}

export interface IBulkUploadResponse<T, C> {
  created: T[];
  errors: IBulkErrorItem<C>[];
}


export enum FormErrorMessages {
  required = 'required',
  pattern = 'pattern',
  min = 'min',
  max = 'max',
  minLength = 'minlength',
  maxLength = 'maxlength',
  email = 'email',
}


export enum AppScreens {
  welcome = 'welcome',
  home = 'home',
  login = 'login',
  register = 'register',
  forgot_password = 'forgot_password',
  reset_password = 'reset_password',
  categories = 'categories',
  product_selection = 'product_selection',
  products = 'products',
  product_detail = 'product_detail',
  profile = 'profile',
  contact_card = 'contact_card',
  edit_profile = 'edit_profile',
  capacitation = 'capacitation',
  questions = 'questions',
  cubator = 'cubator',
  cubator_selection = 'cubator_selection',
  quote_list = 'quote_list',
  quote_form = 'quote_form',
  sale_points = 'sale_points',
  // Promociones
  promotions = 'promotions',
  promotion_detail = 'promotion_detail',
  faq = 'faq',
  certificate = 'certificate',
  certificate_form = 'certificate_form',
  projects = 'projects',
  project_form = 'project_form',
  assistant = 'assistant',
  otp_verification = 'otp_verification',
}